import template from './floor-material-type.jade';
import items from '../../../enums/floor-material-type';

export default angular
  .module('cian.addForm.aboutObjectFloorMaterialType', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfAboutObjectFloorMaterialType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.items = items;
      },
    ],
    controllerAs: 'floorMaterialType',
    template,
  })).name;
